// extracted by mini-css-extract-plugin
module.exports = {"cards":"styles-module--cards--1SrZI","card":"styles-module--card--3XcMY"};